import React, { useState } from "react";
import { X } from "lucide-react";

const VideoDemoModal = ({ videoSrc, onClose }) => {
  return (
    <div
      onClick={onClose} // clicking outside closes it
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(15,23,42,0.75)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999, // above everything, including Swal (which is usually ~9999)
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking the video box itself
        style={{
          position: "relative",
          width: "min(90vw, 900px)",
          background: "#000",
          borderRadius: 20,
          overflow: "hidden",
          boxShadow: "0 25px 60px rgba(0,0,0,0.5)",
        }}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            width: 36,
            height: 36,
            borderRadius: "50%",
            border: "none",
            background: "rgba(255,255,255,0.15)",
            color: "#fff",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <X size={20} />
        </button>

        <video
          src={videoSrc}
          controls
          autoPlay
          style={{ width: "100%", display: "block", maxHeight: "80vh" }}
        />
      </div>
    </div>
  );
};

export default VideoDemoModal;